import styles from "./Cart.module.css";
import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Item from "./Item";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

function Cart({ handleClose, show }) {
  const cartProducts = useSelector((state) => state.user.products);
  const totalPrice = cartProducts.reduce(
    (acc, item) => acc + item.price * item.qty,
    0
  );
  return (
    cartProducts && (
      <>
        <Offcanvas
          className={"h-full " + styles.cart}
          onHide={handleClose}
          show={show}
          placement="end"
        >
          <Offcanvas.Header
            closeButton
            closeVariant="white"
            className="d-flex align-items-center"
          >
            <Offcanvas.Title className={styles.cart_title}>
              Shopping cart
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="d-flex p-0 m-0 flex-column justify-content-between">
            {cartProducts.length > 0 ? (
              <>
                <div>
                  <ul className={"m-0 p-0 " + styles.cart_ul}>
                    {cartProducts.map((product) => {
                      return (
                        <li key={product.id}>
                          <Item product={product} handleCLose={handleClose} />
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="p-2">
                  <div className="d-flex m-0 p-0 justify-content-between">
                    <p className={styles.subtotal + " m-0"}>Subtotal</p>
                    <p className={styles.total_price + " m-0"}>
                      USD {totalPrice.toFixed(2)}
                    </p>
                  </div>
                  <p className={styles.product_price + " mt-0 pt-0"}>
                    Shipping and taxes calculated at checkout.
                  </p>
                  <div className={styles.checkout_container}>
                    <Link
                      to={"/checkout"}
                      onClick={handleClose}
                      className={styles.checkout_btn + " mb-3"}
                    >
                      Checkout
                    </Link>
                  </div>
                  <div className={styles.checkout}>
                    <p className="mb-0">
                      <Link
                        to={"/"}
                        className={styles.continue_shopping + " mt-2"}
                        onClick={handleClose}
                      >
                        Continue Shopping <span> →</span>
                      </Link>
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="d-flex flex-column justify-content-between h-100">
                  <div className={styles.empty_cart}>
                    <i
                      className={
                        "fa-solid fa-cart-shopping mt-3 " +
                        styles.checkout_cart_icon
                      }
                    ></i>
                    <h4 className="mt-3">Your cart is empty!</h4>
                    <p className="mt-3">
                      Looks like your shopping cart is empty, give it some love
                    </p>
                  </div>
                  <div className="p-3">
                    <div className="d-flex m-0 p-0 justify-content-between">
                      <p className={styles.subtotal + " m-0"}>Subtotal</p>
                      <p className={styles.total_price + " m-0"}>
                        USD {totalPrice.toFixed(2)}
                      </p>
                    </div>
                    <p className={styles.product_price + " mt-0 pt-0"}>
                      Shipping and taxes calculated at checkout.
                    </p>
                    <div className={styles.checkout_container + " mb-1"}>
                      <Link
                        to={"/checkout"}
                        onClick={handleClose}
                        className={styles.checkout_btn}
                      >
                        Checkout
                      </Link>
                    </div>
                    <div className={styles.checkout}>
                      <p className="mb-0">
                        <Link
                          to={"/"}
                          className={styles.continue_shopping + " mt-2"}
                          onClick={handleClose}
                        >
                          Continue Shopping <span> →</span>
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </>
    )
  );
}

export default Cart;
